import PropTypes from 'prop-types';

var propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    className: PropTypes.string,
    onDrop: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    'data-testid': 'DropZone',
};

export { defaultProps, propTypes };
